import React, { useState } from 'react'
import { styled } from 'linaria/react'
import { css, cx } from 'linaria'
import { theme } from '../Theme'

import { ReactComponent as PrebookIcon } from '../../svg/Prebook.svg'
import { ReactComponent as OutOfStockIcon } from '../../svg/OutOfStock.svg'
import { ReactComponent as InStockIcon } from '../../svg/InStock.svg'

const RadioLabel = styled.label`
   .product-variant-input {
      opacity: 0;
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
   }

   .product-variant-item {
      user-select: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0.37rem 0px 0.37rem 0.5rem;
      font-size: 1rem;
      color: black;
      font-size: 1rem;
      font-weight: 600;
      font-family: var(--font-grotesk);
      font-stretch: normal;
      font-style: normal;
      line-height: 1.31;
      letter-spacing: normal;
   }

   .product-variant-item:hover {
      color: #195178;
   }

   .product-variant-input:checked + .product-variant-item {
      color: white;
      opacity: 1;
      background-color: #195178;
   }

   .option-value {
      word-break: break-word;;
   }
`

const ProductVariantsContainer = styled.div`
   background-color: white;
   border-radius: ${props =>
      props?.activateScroll ? '20px 20px 0px 20px' : '20px'};
   border: 2px solid rgb(220, 220, 220);
   overflow: hidden;

   .variant-items-container:last-child {
      padding-bottom: 0.2rem;
   }
   .variant-header {
      overflow: hidden;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0.37rem 0px 0.37rem 0.5rem;
      font-size: 1rem;
      color: black;
      font-size: 1rem;
      font-weight: 600;
      font-family: var(--font-grotesk);
      font-stretch: normal;
      font-style: normal;
      line-height: 1.31;
      letter-spacing: normal;
      border-bottom: 2px solid rgb(220, 220, 220);
      background-color: white;
   }

   .text-overflow {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
   }
`

const maxHeightWithScroll = css`
   overflow-y: auto;
   max-height: 165px;
`

export function ListSelect({
   title,
   value,
   options,
   noSelectionHeaderEl,
   onChange,
   ...props
}) {
   const selVal = options?.find(opt => opt.value == value)

   const activateScroll = options && options?.length > 5

   const isChecked = val => value == val

   const radioOptions = options?.map(optionItem => {
      const optionValue = optionItem?.value
      const indicatorElement = optionItem?.indicatorElement
      return (
         <RadioLabel
            key={optionValue}
            htmlFor={optionValue}
            className="radiobutton-label"
         >
            <input
               className="product-variant-input"
               id={optionValue}
               type="radio"
               name="variantGroup"
               value={optionValue}
               onChange={() => onChange(optionValue)}
               checked={isChecked(optionValue)}
            />
            <div className="product-variant-item">
               <span>{indicatorElement}</span>
               <span className="option-value">{optionValue}</span>
            </div>
         </RadioLabel>
      )
   })

   const headerElements = selVal ? (
      <>
         <>
            {selVal?.stockId == 1 ? (
               <InStockIcon></InStockIcon>
            ) : selVal?.stockId == 14 ? (
               <PrebookIcon></PrebookIcon>
            ) : (
               <OutOfStockIcon></OutOfStockIcon>
            )}
         </>
         <span className="text-overflow">{selVal?.value}</span>
      </>
   ) : (
      noSelectionHeaderEl
   )

   return (
      <>
         <ProductVariantsContainer
            activateScroll={activateScroll}
            className="d-flex flex-column"
         >
            <div className="variant-header">{headerElements}</div>
            <div
               className={cx(
                  'variant-items-container d-flex flex-column',
                  activateScroll ? maxHeightWithScroll : ''
               )}
            >
               {radioOptions}
            </div>
         </ProductVariantsContainer>
      </>
   )
}

export default ListSelect
